import { BPFormProvider, Input } from '@bpba/form-components';
import { Button, VStack } from '@bpba/ui-components';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { SignUpAddressRules } from './SignUpAddressRules';
import { CustomerType, IUser } from '../types/IUser';
import useAxios from 'axios-hooks';
import { UrlsBack, UrlsFront } from '../constants/urls';
import { Terms } from './Terms';
import { Titulo } from '../components/shared/Titulo';
import { StyledBox } from '../components/shared/StyledBox';
import { Spinner } from '../components/shared/Spinner';
import { useErrorMessage } from '../components/shared/useErrorMessage';
import { axiosMessageExtractor } from '../config/axiosMessageExtractor';
import { ErrorMessageContainer } from '../components/shared/ErrorMessageContainer';

type ISignUpAddressRequest = {
  address: string | null;
  telephone: string | null;
  terms: boolean;
};

type ISignUpAdressResponse = boolean;

export const SignUpAddressForm = () => {
  const {
    state: { data: user },
  } = useLocation();
  localStorage.setItem('customerName', `${user.name.toUpperCase()}`);

  const navigate = useNavigate();

  const methods = useForm<IUser>({ values: { ...user } });

  const [errorMessage, setErrorMessage, showError, clearError] = useErrorMessage(axiosMessageExtractor);

  const [{ loading }, post] = useAxios<ISignUpAdressResponse, ISignUpAddressRequest>({ url: UrlsBack.SignUpConfirmCustomer, method: 'POST' }, { manual: true });

  const phoneIncomplete = user && user.customerType !== CustomerType.CLIENTE_COMPLETO;
  const addressIncomplete = user?.address?.length == null || user.address.length === 0;

  const onSubmit = async (data: IUser) => {
    const payload = {
      address: addressIncomplete ? data.address : user?.address,
      telephone: phoneIncomplete ? data.telephone : user?.telephone,
      terms: data.terms,
    };

    clearError();

    await post({ data: payload })
      .then((response) => {
        if (response?.data) navigate(UrlsFront.FixedTerms);
        else setErrorMessage();
      })
      .catch(setErrorMessage);
  };

  return (
    <>
      <Titulo>Registro</Titulo> {loading && <Spinner width={40} my={'48px'} />}
      {!loading && (
        <BPFormProvider methods={methods} rules={SignUpAddressRules(addressIncomplete, phoneIncomplete)}>
          <VStack as="form" onSubmit={methods.handleSubmit(onSubmit)}>
            <Input label="Nombre" readOnly control={methods.control} name="name" />
            <Input label="CUIT" readOnly control={methods.control} name="taxNumber" />
            {addressIncomplete && <Input label="Domicilio" name="address" control={methods.control} placeholder="Domicilio" />}
            {phoneIncomplete && <Input label="Teléfono" name="telephone" control={methods.control} placeholder="Telefono" />}

            <Input name="terms" type="checkbox" control={methods.control} label={<Terms />} />

            <ErrorMessageContainer show={showError} errorMessage={errorMessage} mt={0} mb={16} />

            <StyledBox>
              <Button
                m={'0px !important'}
                type="button"
                variant="transparent"
                onClick={() => {
                  navigate('/registro');
                }}
              >
                Cancelar
              </Button>
              <Button m={'0px !important'} type="submit" variant="secondary">
                Confirmar
              </Button>
            </StyledBox>
          </VStack>
        </BPFormProvider>
      )}
    </>
  );
};
